import React, { Component, useDebugValue } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import uniq from "lodash/uniq";
import moment from "moment";
import {
  Form,
  FormGroup,
  FormFeedback,
  Col,
  Label,
  Input,
  Button,
  Row,
  CustomInput,
  Popover,
  PopoverHeader,
  PopoverBody,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import Tooltip from "../../../../../components/UI/TooltipIcon/TooptipIcon";
// import ErrorMessage from '../../../../components/Message/ErrorMessage/ErrorMessage';
import Toggle from "react-toggle";
import "react-toggle/style.css";
import Select from "react-select";
import Loading from "../../../../../hoc/Loading/Loading";
import axios from "../../../../../axios";
import * as actionCreators from "../../../../../modules/actions/index";
import * as url from "../../../../../utils/url";
import LinkChart from "../../../../../assets/placeholders/dashboard_sample.png";
import {
  privacyLabel,
  newDashboard,
  checkUserPrivileges,
} from "../../../../../utils/constants";
// import Dropdown from '../../Reusable/Dropdown'
import DatePicker from "react-datepicker";
import CreateDashboard from "../../Reusable/CreateDashboard";
import EditDashboard from "../../Reusable/EditDashboard";
import ActivityLog from "../../Components/DashboardActivity";
import ArchiveDashboard from "../../Reusable/ArchiveDashboard";
import DashboardNotesList from "./../AddNotes/DashboardNotesList";
import DashboardReports from "../../Reports/DashboardReports";

class DashboardSettings extends Component {
  filterMenuRef = React.createRef();
  filterMenuBtnRef = React.createRef();
  filterMenuOlRef = React.createRef();
  filterMenuOptionRef = React.createRef();

 

  constructor(props) {
    super(props);
    this.state = {
      shouldUpdate: false,
      dropdownDashboardView: false,
      isActivityLog: false,
      // title : this.props.currentDashboard.name?this.props.currentDashboard.name:'',
      name: this.props.currentDashboard.name,
      customUser: "",
      newUserAdded: null,
      showNotes: false,
      preventCreate: false,
      url: "",
      isCreateBtntxt: false,
      openActivity: false,
      isArchiveModal: false,
      dropdownOpen: false,
      dropdownFilter: false,
      isNotesDisplay: false,
      isCreateDashboard: false,
      isDateApplied: false,
      dropdownAction: false,
      isDatePicker: false,
      privacy: this.props.currentDashboard.privacy,
      permission: this.props.currentDashboard.permission,
      isResourceSelect: null,
      startDate: this.props.startDate ? moment(this.props.startDate) : null,
      currentDashboard: this.props.currentDashboard,
      endDate: this.props.endDate ? moment(this.props.endDate) : null,
      isPrivacySettingsChanged: false,
      error: false,
      activeFilterMenu: "",
      isShowInsights: false,
      errorMessage: "",
      displayUsers: [],
      isPrivacy: false,
      isUserList: false,
      invitedUsers: this.props.currentDashboard.invitedUsers,
      privacyPopoverOpen: false,
      permissionPopoverOpen: false,
      filteredBenchmarkData: null,
      updatedFields: [],
      displayType: null,
      isCreateModal: false,
      dashboardOwner:
        this.props.dashboardOwner &&
        this.props.dashboardOwner.firstName &&
        this.props.dashboardOwner.lastName
          ? this.props.dashboardOwner.firstName +
            " " +
            this.props.dashboardOwner.lastName
          : !this.props.dashboardOwner.lastName ||
            this.props.dashboardOwner.lastName == ""
          ? this.props.dashboardOwner.firstName
          : this.props.dashboardOwner.role,
    };
    this.timer = null;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    const queryParams = new URLSearchParams(window.location.search);

    if (queryParams.get("report")) {
      this.setState({ isNotesDisplay: true });
     
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  editTask = (field, isUndo) => {
    // console.log('field---', field)
    let { updatedFields, task_copy, task, removedFields } = this.state;

    if (updatedFields.indexOf(field) == -1) {
      updatedFields.push(field);
      this.setState({ updatedFields });
    } else {
      let res = updatedFields.filter((e) => e != field);

      this.setState({ updatedFields: res });
    }
  };

  getUserList = () => {
    let { displayUsers } = this.state;
    if (displayUsers.length === 0) {
      axios
        .get(url.userListArray)
        .then((response) => {
          this.setState({
            displayUsers: response.data.data.map((e) => {
              if (e.firstName && e.lastName) {
                return {
                  label: `${e.firstName}, ${e.lastName}`,
                  value: e._id,
                  permissions: 0,
                };
              } else if (e.firstName || e.lastName) {
                let name =
                  e.firstName && e.firstName.length > 0
                    ? e.firstName
                    : e.lastName;
                return { label: `${name}`, value: e._id, permissions: 0 };
              } else if (!e.firstName && !e.lastName) {
                return { label: `${e.email}`, value: e._id, permissions: 0 };
              }
            }),
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleOptionChange = (changeEvent) => {
    // console.log(changeEvent.target)
    let permission = "";
    if (changeEvent === "ENTERPRISE") {
      permission = "VIEW";
      this.setState({
        privacy: changeEvent,
        permission,
        invitedUsers: [],
        isUserList: false,
      });
    } else if (changeEvent === "CUSTOM") {
      this.setState({
        isUserList: true,
        privacy: changeEvent,
      });
      // this.getUserList()
    } else {
      this.setState({
        privacy: changeEvent,
        permission: "VIEW",
        invitedUsers: [],
        isUserList: false,
      });
    }
  };

  handlePermissionChange = () => {
    let permission = this.state.permission === "EDIT" ? "VIEW" : "EDIT";
    this.setState({ permission: permission });
  };

  // Toggle popover
  togglePrivacySettings = () => {
    this.setState({
      privacyPopoverOpen: !this.state.privacyPopoverOpen,
      permissionPopoverOpen: false,
    });
  };

  togglePersmission = () => {
    this.setState({
      permissionPopoverOpen: !this.state.permissionPopoverOpen,
      privacyPopoverOpen: false,
    });
  };

  onUserSelect = (u) => {
    let { invitedUsers } = this.state;

    let result =
      invitedUsers.length == 0 ||
      invitedUsers.filter((item) => item.userId == u._id).length == 0
        ? invitedUsers.concat({
            firstName: u.firstName,
            lastName: u.lastName,
            userId: u._id,
            orgId: u.organizationId,
            permissions: 0,
          })
        : invitedUsers;

    this.setState({ invitedUsers: result });
  };

  onUserSetPermissions = (p, u) => {
    // console.log(p, u)
    let { invitedUsers } = this.state;
    if (p && p != null && p != undefined) {
      invitedUsers.forEach((item, index) => {
        if (item.userId == u.userId) {
          invitedUsers[index].permissions = p.value;
        }
      });
      this.setState({ invitedUsers });
    } else {
      invitedUsers.forEach((item, index) => {
        if (item.userId == u.userId) {
          invitedUsers[index].permissions = { label: "View", value: 0 };
        }
      });
      this.setState({ invitedUsers });
    }
  };

  renderDropDownViews = () => {
    let { privacy } = this.state;
    if (privacy) {
      return (
        <Dropdown
          isOpen={this.state.dropdownOpen}
          toggle={this.toggleTaskView}
          className="dbPrivacyDropdown"
        >
          <DropdownToggle caret>{privacyLabel[privacy]}</DropdownToggle>
          <DropdownMenu className="privacyOptionsContainer">
            {/* <DropdownItem header>Select a view</DropdownItem> */}
            <DropdownItem
              className="privacyBtnItem"
              onClick={() => this.handleOptionChange("PRIVATE")}
            >
              {privacyLabel["PRIVATE"]}
            </DropdownItem>
            <DropdownItem
              className="privacyBtnItem"
              onClick={() => this.handleOptionChange("ENTERPRISE")}
            >
              {privacyLabel["ENTERPRISE"]}
            </DropdownItem>
            <DropdownItem
              className="privacyBtnItem"
              onClick={() => this.handleOptionChange("CUSTOM")}
            >
              {privacyLabel["CUSTOM"]}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      );
    }
  };

  privacyContent = (type) => {
    let { privacy } = this.state;

    if (privacy) {
      if (type === "enable") {
        return (
          <div className="dbPrivacyStatusContainer">
            <span className="dbPrivacyStatusTxt">
              Privacy Status:
              {this.renderDropDownViews()}
            </span>
          </div>
        );
      } else {
        return <span className="dashboard-privacy-label">{privacy}</span>;
      }
    }
  };

  renderPrivacyOptions = () => {
    return this.privacyContent("enable");
    // if(chartDetails && chartDetails.createdBy  && chartDetails.createdBy._id){
    //     if(chartDetails.createdBy._id===user._id){
    //       return this.privacyContent("enable")
    //     } else if(isCopied) {
    //       return this.privacyContent("enable")
    //     } else {
    //       return this.privacyContent("disable")
    //     }
    // } else {
    //   return this.privacyContent("enable")
    // }
  };

  toggleTaskView = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
      // dropdownFilter: !prevState.dropdownFilter
    }));
  };

  removeUser = (user) => {
    // console.log('u: ', user)
    let { invitedUsers } = this.state;
    invitedUsers = invitedUsers.filter(
      (e) => e.userId.toString() != user.userId.toString()
    );
    this.setState({ invitedUsers });
  };

  assignedUserDelay = ({ target }) => {
    let { value } = target;
    this.setState({ customUser: value });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleAssignUser(value);
    }, 1000);
  };

  renderPermissions = () => {
    let {
      privacy,
      invitedUsers,
      displayUsers,
      isUserList,
      customUser,
    } = this.state;
    if (privacy) {
      if (privacy == "ENTERPRISE") {
        return (
          <span className="permissionsContainer">
            {/* <div className="float-right"> */}
            {/* <span id="permission-popover" style={{ marginRight: '10px' }} onClick={this.togglePersmission}><Tooltip /></span> */}
            <span className="dashboard-permission-label">Permissions:</span>
            {/* <Popover placement="left" isOpen={this.state.permissionPopoverOpen} target="permission-popover" toggle={this.togglePersmission}>
                <PopoverHeader className="popover-header-tooltip">Permissions</PopoverHeader>
                <PopoverBody className="popover-body-tooltip">Toggle from “View Only” to “View and Edit” to allow others you have shared this chart with, to make modifications to it. Note, you can always change the privacy settings and permissions again and/or at a later time.</PopoverBody>
              </Popover> */}
            {/* </div> */}
            <div className="dashboardPermissionOptions">
              <span className="dbPermissionValue">View Only</span>
              <span className="ml10">
                <Toggle
                  defaultChecked={this.state.permission === "EDIT"}
                  icons={false}
                  onChange={this.handlePermissionChange}
                />
              </span>
              <span className="dbPermissionValue ml10">View And Edit</span>
            </div>
          </span>
        );
      } else if (privacy == "CUSTOM" && isUserList) {
        return (
          <span>
            {/* <Col sm={3} md={3} lg={3}>
                <div className="float-right">
                  <span id="permission-popover" style={{ marginRight: '10px' }} onClick={this.togglePersmission}><Tooltip /></span>
                    <span className="chart-permission-label float-right">
                      <span>Shared with</span>
                    </span>
                  <Popover placement="left" isOpen={this.state.permissionPopoverOpen} target="permission-popover" toggle={this.togglePersmission}>
                    <PopoverHeader className="popover-header-tooltip"> Sharing </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      Selects users you would like to share this dashboard with.
                      </PopoverBody>
                  </Popover>
                </div>
              </Col> */}

            {/* <Col sm={2} className="">
                    <div className="chartLabel">Select Users</div>
                  </Col> */}
            <span className="permissionsContainer">
              <input
                // ref={this.inviteUserRef}
                name="assignedUser"
                id=""
                placeholder={"Select users to share this dashboard with"}
                className="inputBox-height"
                onChange={this.assignedUserDelay}
                value={customUser}
                autoComplete={"off"}
              />
              {displayUsers &&
              displayUsers.length > 0 &&
              typeof displayUsers !== "string" ? (
                <div className="divTableSingleTask">
                  <div className="dbTableBody">
                    {displayUsers.map((user) => {
                      return (
                        <div
                          className="divTableRow"
                          onClick={() => this.onUserSelect(user)}
                          key={user._id + user.organizationId}
                        >
                          <div className="dashboardTableCell">
                            {user.firstName} {user.lastName}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : typeof displayUsers === "string" ? (
                <span className="noUsersFound">{displayUsers}</span>
              ) : null}
            </span>

            {invitedUsers.length > 0 ? (
              <Table responsive hover className="dbPrivacyTable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Access</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {invitedUsers.map((e) => {
                    let fullName = e.firstName + " " + e.lastName;
                    return (
                      <tr className="dbPrivacyRow" key={e.userId}>
                        <td>{fullName}</td>

                        <td>
                          <Select
                            isClearable={false}
                            name="permission-select"
                            placeholder={"Select a permission/privacy"}
                            value={e.permissions}
                            isOpen={true}
                            options={[
                              { label: "View", value: 0 },
                              { label: "Edit", value: 1 },
                            ]}
                            onChange={(itm) =>
                              this.onUserSetPermissions(itm, e)
                            }
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </td>

                        <td className="dbRemoveUserCol">
                          <i
                            onClick={() => this.removeUser(e)}
                            className="dashboardUserIcon flaticon-trash"
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : null}
          </span>
        );
      }
    }
  };

  handleAssignUser = (value) => {
    // console.log('val---', value)
    let res;
    if (value && value.length > 0) {
      axios.get(url.findUser(value)).then((resp, idx) => {
        let users = resp.data.data;
        // console.log('users--', users)
        if (users.length == 0) {
          users = "No users found";
        }

        this.setState({ displayUsers: users });
      });
    } else {
      this.setState({ displayUsers: [] });
    }
  };

  privacySettingsModal = () => {
    this.setState((prevState) => ({
      isPrivacy: !prevState.isPrivacy,
    }));
  };

  closeActionsModal = () => {
    // console.log('settings: ', this.props)
    // console.log('state: ', this.state)
    this.setState((prevState) => ({
      ...newDashboard,
    }));
  };

  changePrivacySettings = () => {
    this.setState((prevState) => ({
      isPrivacy: false,
    }));
  };

  toggleFilterDd = () => {
    this.setState((prevState) => ({
      dropdownFilter: !prevState.dropdownFilter,
    }));
  };

  showFilterMenu = (type) => {
    this.setState({ activeFilterMenu: type });
  };

  clearActiveMenu = () => {
    this.setState({ activeFilterMenu: "" });
  };

  renderActiveMenu = () => {
    let { activeFilterMenu } = this.state;
    if (activeFilterMenu == "date") {
      return this.renderDatePicker();
    }
    if (activeFilterMenu == "category") {
      return this.renderCategories();
    }
  };

  closeFilterMenu = () => {
    this.setState((prevState) => ({ dropdownFilter: false }));
  };

  openFilterMenu = () => {
    this.setState((prevState) => ({
      dropdownFilter: !prevState.dropdownFilter,
      activeFilterMenu: "",
    }));
  };

  handleClickOutside = (event) => {
    let filterMenuOption =
      this.filterMenuOptionRef &&
      this.filterMenuOptionRef.current &&
      !this.filterMenuOptionRef.current.contains(event.target);
    let filterMenuOl =
      this.filterMenuOlRef &&
      this.filterMenuOlRef.current &&
      !this.filterMenuOlRef.current.contains(event.target);
    let filterMenu =
      this.filterMenuRef &&
      this.filterMenuRef.current &&
      !this.filterMenuRef.current.contains(event.target);
    let filterMenuBtn =
      this.filterMenuBtnRef &&
      this.filterMenuBtnRef.current &&
      !this.filterMenuBtnRef.current.contains(event.target);

    if (
      (filterMenuOption || filterMenuOption == null) &&
      (filterMenuOl || filterMenuOl == null) &&
      (filterMenu || filterMenu == null) &&
      (filterMenuBtn || filterMenuBtn == null)
    ) {
      this.closeFilterMenu();
    }
  };

  renderFilterDropdown = () => {
    let { dropdownFilter, activeFilterMenu } = this.state;
    // console.log('dropdownFilter: ', dropdownFilter)
    let { reports, user, currentDashboard } = this.props;

    if (dropdownFilter) {
      return (
        <ul className="dbFilterDropdown" ref={this.filterMenuRef}>
          <span className="dbFilterLabel">Choose filters</span>
          {activeFilterMenu == "" ? (
            <span ref={this.filterMenuOlRef}>
              {checkUserPrivileges(user.profile, currentDashboard) &&
              checkUserPrivileges(user.profile, currentDashboard) != "VIEW" ? (
                <ol
                  onClick={
                    checkUserPrivileges(user.profile, reports)
                      ? () => this.showFilterMenu("date")
                      : null
                  }
                >
                  {" "}
                  Date Range{" "}
                </ol>
              ) : null}
              <ol onClick={() => this.showFilterMenu("category")}>
                {" "}
                Category{" "}
              </ol>
            </span>
          ) : (
            <span ref={this.filterMenuOptionRef}>
              {this.renderActiveMenu()}
            </span>
          )}
        </ul>
      );
    }
  };

  handleStartDatePicker = (id) => {
    document.getElementById(id).click();
  };

  handleEndDateChange = (date) => {
    if (!date) {
      return;
    }
    if (this.state.startDate != null && date < this.state.startDate) {
      this.setState({
        endDate: this.state.startDate,
        error: false,
      });
    } else {
      this.setState({
        endDate: date,
        error: false,
      });
    }
  };

  handleStartDateChange = (date) => {
    // console.log(date)

    if (!date) {
      return;
    }

    if (this.state.endDate !== null && date > this.state.endDate) {
      this.setState({
        startDate: this.state.endDate,
        error: false,
      });
    } else {
      this.setState({
        startDate: date,
        error: false,
      });
    }
  };

  categoryFilter = (e) => {
    let { currentDashboard } = this.state;
    let { isCategory } = currentDashboard;

    if (e == "All") {
      this.props.updateReport({ isCategory: [] });
      this.setState({
        currentDashboard: { ...currentDashboard, isCategory: [] },
      });
    } else {
      if (isCategory && isCategory.indexOf(e) > -1) {
        let result = isCategory.filter((cat) => cat != e);
        this.props.updateReport({ isCategory: result });
        this.setState({
          currentDashboard: { ...currentDashboard, isCategory: result },
        });
      } else {
        if (isCategory && isCategory.length > 0) {
          let result = isCategory.concat(e);
          this.props.updateReport({ isCategory: result });
          this.setState({
            currentDashboard: { ...currentDashboard, isCategory: result },
          });
        } else {
          let result = [e];
          this.props.updateReport({ isCategory: result });
          this.setState({
            currentDashboard: { ...currentDashboard, isCategory: result },
          });
        }
      }
    }

    // this.openFilterMenu()
  };

  renderCategories = () => {
    let { reportCharts, reports } = this.props;

    if (reportCharts && reportCharts.length > 0) {
      let categories = reportCharts.map((e) => e.category);
      categories = uniq(categories);
      return (
        <div className="dateFilterContainer">
          <span
            className="dashboardDateOptions"
            onClick={() => this.clearActiveMenu()}
          >
            {" "}
            {"< "}Back{" "}
          </span>
          <div className="dbCategoryFilterOptions">
            <ol onClick={() => this.categoryFilter("All")}> All </ol>
            {categories.map((e) => {
              return (
                <ol onClick={() => this.categoryFilter(e)} key={e + Date.now()}>
                  {" "}
                  {e}{" "}
                  {reports.isCategory &&
                  reports.isCategory.length > 0 &&
                  reports.isCategory.indexOf(e) > -1 ? (
                    <span className="dbSelectedCategory">(selected)</span>
                  ) : null}{" "}
                </ol>
              );
            })}
          </div>
          <div className="dbFilterInfoTxt">
            *click to select/deselect categories above
          </div>
        </div>
      );
    } else {
      return (
        <div className="dateFilterContainer">
          <span
            className="dashboardDateOptions"
            onClick={() => this.clearActiveMenu()}
          >
            {" "}
            {"< "}Back{" "}
          </span>
          <div className="dbCatFilterTxt">
            No category filters available. Please add charts to filter.
          </div>
        </div>
      );
    }
  };

  openDatePicker = (id) => {
    document.getElementById(id).click();
  };

  renderDatePicker = () => {
    return (
      <div className="dateFilterContainer">
        <span
          className="dashboardDateOptions"
          onClick={() => this.clearActiveMenu()}
        >
          {" "}
          {"< "}Back{" "}
        </span>
        <div>
          <div className="inner-addon right-addon dateFilterPicker">
            {/* Start Date */}
            <span
              className="tool-start-date flaticon-calendar"
              onClick={() => this.openDatePicker("startDatePicker")}
            />
            <DatePicker
              id="startDatePicker"
              placeholderText="Select start date"
              className="input-custom-date form-control"
              selectsStart
              showYearDropdown
              // selected={this.state.startDate}
              selected={
                this.state.startDate ? moment.utc(this.state.startDate) : null
              }
              startDate={
                this.state.startDate ? moment.utc(this.state.startDate) : null
              }
              onChange={this.handleStartDateChange}
              //  startDate={moment.utc(this.state.startDate)}
              endDate={
                this.state.endDate ? moment.utc(this.state.endDate) : null
              }
            />
          </div>
          <span className="mg10">to</span>
          <div className="inner-addon right-addon dateFilterPicker">
            {/* End Date */}
            <span className="tool-end-date">
              <span
                className="flaticon-calendar"
                onClick={() => this.openDatePicker("endDatePicker")}
              />
            </span>
            <DatePicker
              id="endDatePicker"
              placeholderText="Select end date"
              className="input-custom-date form-control"
              selectsEnd
              showYearDropdown
              selected={
                this.state.endDate ? moment.utc(this.state.endDate) : null
              }
              onChange={this.handleEndDateChange}
              startDate={
                this.state.startDate ? moment.utc(this.state.startDate) : null
              }
              endDate={
                this.state.endDate ? moment.utc(this.state.endDate) : null
              }
              disabled={!this.state.startDate}
              minDate={
                this.state.startDate ? moment.utc(this.state.startDate) : null
              }
              maxDate={moment(new Date())}
            />
          </div>
        </div>

        <div className="d-flex">
        <Button
          outline
          color="primary"
          className="dashboardDateOptions"
          onClick={() => this.applyDateFilter()}
          style={{display:"inline"}}
        >
          {" "}
          Apply{" "}
        </Button>

          <Button
            outline
            color="danger"
            className="dashboardDateOptions ml-2"
            onClick={() => this.clearDateFilter()}
            disabled={this.state.startDate && this.state.endDate ? false : true}
          >
            {" "}
            Clear{" "}
          </Button>
        </div>
      </div>
    );
  };

  saveDashboard = () => {
    let {
      permission,
      privacy,
      invitedUsers,
      title,
      startDate,
      endDate,
      currentDashboard,
    } = this.state;
    let obj = {
      _id: currentDashboard._id,
      dashboardAttr: {
        permission,
        privacy,
        invitedUsers,
        name: title,
        startDate,
        endDate,
      },
    };
    this.props.saveDashboard(obj);
  };

  // updateDashboardSettings=(result)=>{
  //   let{currentDashboard}=this.state
  //   let dashboardObj = {
  //     _id:currentDashboard._id,
  //     dashboardAttr:{
  //       ...result
  //     }
  //   }

  //   this.setState({ isPrivacy:false  })
  //   this.props.updateDashboardSettings(dashboardObj)
  // }

  createDashboardModal = () => {
    this.setState({ isCreateModal: true });
  };

  newDashboardUrl = (url) => {
    this.props.newDashboardUrl(url);
  };

  openDetailsModal = () => {
    this.setState({
      isPrivacy: true,
      currentDashboard: { ...this.props.reports },
    });
  };
  openActivityLog = (bool) => {
    this.setState({ isActivityLog: bool });
  };

  toggleDashboardView = (view) => {
    console.log("viw --- ", view);
    if (view) {
      let isChartsView = view == "charts" ? true : false;
      // let { isNotesDisplay } = this.state;
      this.setState((prevState) => ({ isNotesDisplay: !isChartsView }));
      this.props.updateReport({ hideCharts: !isChartsView });

      if(isChartsView){
        const queryParams = new URLSearchParams(window.location.search);

        if(queryParams.get("report")){
          queryParams.delete("report");

          this.props.history.replace({
            search: queryParams.toString(),
          });
        }
       
      }
    } else {
      let { isNotesDisplay } = this.state;
      this.setState((prevState) => ({
        isNotesDisplay: !prevState.isNotesDisplay,
      }));
      this.props.updateReport({ hideCharts: !isNotesDisplay });
    }
  };

  openEmailModal = () => {};
  // createPublicUrl=()=>{ }
  openDeleteDashboard = () => {
    this.setState({ isArchiveModal: true });
  };

  toggleActionsView = () => {
    this.setState((prevState) => ({
      dropdownAction: !prevState.dropdownAction,
    }));
  };

  openUploadModal = () => {
    this.props.updateReport({ isUploadFiles: true });
  };

  renderActionsDropdown = () => {
    let { currentDashboard, user } = this.props;
    // console.log('show props: ', this.props)
    return (
      <Dropdown
        isOpen={this.state.dropdownAction}
        toggle={this.toggleActionsView}
        className="dashboardActionsDd"
      >
        <DropdownToggle caret className="dbActionBtn">
          Actions
        </DropdownToggle>
        <DropdownMenu className="singleTaskViewMenu">
          {/* <DropdownItem header>Select a view</DropdownItem> */}

          {checkUserPrivileges(user.profile, currentDashboard) ? (
            <DropdownItem
              className="chartBtnView"
              onClick={
                checkUserPrivileges(user.profile, currentDashboard)
                  ? () => this.openDetailsModal()
                  : null
              }
            >
              Dashboard Details
            </DropdownItem>
          ) : null}

          <DropdownItem
            className="chartBtnView"
            onClick={() => this.openActivityLog(true)}
          >
            {" "}
            Activity Log{" "}
          </DropdownItem>

          {checkUserPrivileges(user.profile, currentDashboard) ? (
            <DropdownItem
              className="chartBtnView"
              onClick={() => this.openUploadModal()}
            >
              {" "}
              Upload Files{" "}
            </DropdownItem>
          ) : null}

          {checkUserPrivileges(user.profile, currentDashboard, "owner") ? (
            <DropdownItem
              className="toolkitBtnView"
              onClick={() => this.openDeleteDashboard()}
            >
              {" "}
              Delete{" "}
            </DropdownItem>
          ) : null}
        </DropdownMenu>
      </Dropdown>
    );
  };

  applyDateFilter = () => {
    let { startDate, endDate } = this.state;

    if (!endDate) {
      endDate = moment(new Date());
    }
    if (!startDate) {
      startDate = moment(new Date());
    }

    if (!startDate && !endDate) {
      startDate = null;
      endDate = null;
    }

    this.setState({
      isDateApplied: true,
      dropdownFilter: false,
      activeFilterMenu: "",
      startDate,
      endDate
    });
    this.props.onDateChange(startDate, endDate);
  };
  
  clearDateFilter = () => {
   
   let   startDate = null;
   let   endDate = null;
    

    this.setState({
      isDateApplied: true,
      dropdownFilter: false,
      activeFilterMenu: "",
      startDate:moment(new Date()),
      endDate:moment(new Date())
    });
    this.props.onDateChange(startDate, endDate);
  };

  clearDateFilter = () => {
    this.setState({
      isDateApplied: true,
      dropdownFilter: false,
      activeFilterMenu: "",
      startDate: null,
      endDate: null,
    });
    this.props.onDateChange(null, null);
  };

  renderPrivacyStatus = () => {
    let status = "Custom";
    let { reports } = this.props;
    let { privacy, permission } = reports;
    if (privacy === "PRIVATE") {
      status = "Owner only";
    }

    if (privacy == "ENTERPRISE") {
      if (permission == "VIEW") {
        status = "Everyone can view";
      } else {
        status = "Everyone can edit";
      }
    }
    return status;
  };

  toggleDashboardViewDd = () => {
    this.setState((prevState) => ({
      dropdownDashboardView: !prevState.dropdownDashboardView,
    }));
  };

  removeDates = () => {};

  showCreateBtnTxt = () => {
    this.setState((prevState) => ({
      isCreateBtntxt: !prevState.isCreateBtntxt,
    }));
  };

  showInsightsPanel = () => {
    let { isShowInsights } = this.state;
    isShowInsights
      ? (document.body.style.overflow = "auto")
      : (document.body.style.overflow = "hidden");
    this.setState((prevState) => ({
      isShowInsights: !prevState.isShowInsights,
    }));
  };

  render() {
    let {
      privacy,
      isDateApplied,
      dashboardOwner,
      openActivity,
      isShowInsights,
      isActivityLog,
      currentDashboard,
      isArchiveModal,
      name,
      isPrivacy,
      startDate,
      endDate,
      isCreateModal,
      isNotesDisplay,
    } = this.state;

    let viewsArray = [
      { label: "Charts View", value: 0 },
      { label: "Reports View", value: 1 },
    ];
    let views = ["Analytics", "Attachments"];

    let isEdit = checkUserPrivileges(this.props.user.profile, currentDashboard);

    console.log("isNotesDisplay ---- ", isNotesDisplay);

    return (
      <span className="dashboardSettingsContainer col-md-12">
        <span className="dashboardCreateTitleContainer">
          <h5 className="dashboardCreateTitleInput">
            {this.props.reports.name
              ? this.props.reports.name
              : "Dashboard Title"}
          </h5>
          {this.renderActionsDropdown()}

          <Button
            outline
            // color="warning"
            className={`single-dashboard-reports-button ${
              !isNotesDisplay ? "single-dashboard-report-button-inactive" : ""
            }`}
            onClick={() => this.toggleDashboardView("reports")}
          >
            {" "}
            Reports
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi-lightning"
              viewBox="0 0 16 16"
            >
              <path d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5zM6.374 1 4.168 8.5H7.5a.5.5 0 0 1 .478.647L6.78 13.04 11.478 7H8a.5.5 0 0 1-.474-.658L9.306 1H6.374z" />
            </svg>{" "} */}
          </Button>

          <Button
            outline
            // color="warning"
            className={`single-dashboard-analytics-button ${
              isNotesDisplay ? "single-dashboard-analytics-button-inactive" : ""
            }`}
            onClick={() => this.toggleDashboardView("charts")}
          >
            {" "}
            Analytics
          </Button>

          {/* <Dropdown
            isOpen={this.state.dropdownDashboardView}
            toggle={this.toggleDashboardViewDd}
            className="dashboardSelectedViewContainer"
          >
            <DropdownToggle caret className="dbViewBtnTxt">
              {!isNotesDisplay ? views[0] : views[1]}
            </DropdownToggle>
            <DropdownMenu className="dashboardViewMenu">
              <DropdownItem
                className="chartBtnView"
                onClick={() => this.toggleDashboardView()}
              >
                {" "}
                {isNotesDisplay ? views[0] : views[1]}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown> */}

          <Button
            color="info"
            className="createDashboardBtn"
            onClick={() => this.createDashboardModal()}
            onMouseEnter={this.showCreateBtnTxt}
            onMouseLeave={this.showCreateBtnTxt}
            // onMouseOver={this.showCreateBtnTxt}
          >
            {" "}
            <span className="flaticon-plus" />
            {this.state.isCreateBtntxt ? " Create a dashboard" : null}
          </Button>
        </span>

        <div
          className={`dashboardPrivacyFilterContainer ${
            isNotesDisplay ? "hide" : ""
          }`}
        >
          <span
            className="dashboardFilterContainer"
            onClick={() => this.openFilterMenu()}
            ref={this.filterMenuBtnRef}
          >
            <i className="flaticon-equalizer" />
            Filter charts
          </span>
          {this.renderFilterDropdown()}

          {(isDateApplied && this.state.startDate) || (startDate && endDate) ? (
            <span className="dashboardDates">
              {/* <span onClick={()=>this.removeDates()}>X</span> */}
              <span className="dbDateRange">Date range:</span>{" "}
              {moment.utc(startDate).format("MMMM D, YYYY")} -{" "}
              {moment.utc(endDate).format("MMMM D, YYYY")}
            </span>
          ) : null}

          {currentDashboard &&
          currentDashboard.isCategory &&
          currentDashboard.isCategory != "All" ? (
            <span className="dashboardCategoryFilterList">
              {currentDashboard.isCategory.slice(0, 2).map((cat) => {
                return (
                  <span
                    className="dashboardDates dashboardCategoryFilterSelected"
                    key={cat}
                  >
                    <span className="dbDateRange">{cat}</span>
                  </span>
                );
              })}
            </span>
          ) : null}

          <span className="dashboardPrivacyContainer">
            <span className="dashboard-privacy-label">Privacy setting:</span>
            {isEdit ? (
              <span
                className="dbPrivacyLabel"
                onClick={() => this.privacySettingsModal()}
              >
                {this.renderPrivacyStatus()}
              </span>
            ) : (
              <span className="dashboard-privacy-label">
                {this.renderPrivacyStatus()}
              </span>
            )}
          </span>

          {currentDashboard &&
          currentDashboard.isCategory &&
          currentDashboard.isCategory != "All" &&
          currentDashboard.isCategory.length > 2 ? (
            <span className="dashboardCategoryFilterList">
              {currentDashboard.isCategory.slice(2).map((cat) => {
                return (
                  <span
                    className="dashboardDates dashboardCategoryFilterSelected"
                    key={cat}
                  >
                    <span className="dbDateRange">{cat}</span>
                  </span>
                );
              })}
            </span>
          ) : null}
        </div>

        {isShowInsights ? (
          <div className="dashboardInsightPanel">
            <span className="closebtn" onClick={this.showInsightsPanel}>
              &times;
            </span>
            <DashboardReports />
          </div>
        ) : null}

        <CreateDashboard
          isCreateModal={isCreateModal}
          closeActionsModal={this.closeActionsModal}
          newDashboardUrl={this.newDashboardUrl}
        />

        {isPrivacy ? (
          <EditDashboard
            dashboardOwner={dashboardOwner}
            changeDashboardTitle={this.changeDashboardTitle}
            closeActionsModal={this.closeActionsModal}
            currentDashboard={this.state.currentDashboard}
            // dashboardCopy={this.props.reports}
          />
        ) : null}

        <ActivityLog
          openActivity={openActivity}
          isActivityLog={isActivityLog}
          currentDashboard={this.props.reports}
          openActivityLog={this.openActivityLog}
        />

        <ArchiveDashboard
          isArchiveModal={isArchiveModal}
          currentDashboard={this.props.reports}
          closeActionsModal={this.closeActionsModal}
          newDashboardUrl={this.newDashboardUrl}
        />
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
    reportCharts: state.reports.charts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(DashboardSettings, axios)));
